export default {
  'user-login.login.login': 'Login',
  'user-login.login.message-invalid-credentials':
    'Invalid username or password',
}
